// extracted by mini-css-extract-plugin
export default {"container":"PronunciationSelectView_container__10eUF"};